<div class="flex w-full justify-center items-center">
  <div class="text-center">
    <h2 class="text-2xl text-red-700 py-4">{{ 'COMPONENT.CONTACT_FORM.ERROR_TITLE' | translate }}</h2>
    <h3 class="text-lg pb-2">{{ 'COMPONENT.CONTACT_FORM.ERROR_DESCRIPTION' | translate }}</h3>
  </div>
</div>
